/** IANA timezones from the platform, with a small fallback for older runtimes. */
export const TIMEZONES: string[] = (() => {
  const intl = Intl as typeof Intl & { supportedValuesOf?: (key: string) => string[] };
  if (typeof intl.supportedValuesOf === 'function') {
    return intl.supportedValuesOf('timeZone');
  }
  return [
    'UTC',
    'Europe/London',
    'Europe/Dublin',
    'America/New_York',
    'America/Chicago',
    'America/Los_Angeles',
    'Asia/Tokyo',
    'Asia/Singapore',
    'Australia/Sydney',
  ];
})();

export const OVERLAP_POLICIES = ['skip', 'allow'];
export const CATCHUP_POLICIES = ['fire_once', 'skip'];
export const QUEUES = ['default', 'weekly_reports', 'maintenance', 'campaign_creation', 'landing_pages', 'scheduler'];
